import { AuthProvider } from 'context/AuthContext'
import { MediaProvider } from 'context/MediaContext'

import { createTheme, ThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'

import { BrowserRouter, Route, Routes } from 'react-router-dom'
import PrivateRoute from 'component/PrivateRoute'

import Root from 'component/Root'
import AuthByTwitter from 'component/Authentication/AuthByTwitter';

const theme = createTheme({
  palette: {
    mode: 'dark',
  }
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <MediaProvider>
        <CssBaseline>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path='/auth' element={<AuthByTwitter />} />
                <Route path='/*' element={<PrivateRoute children={<Root />} />} />
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </CssBaseline>
      </MediaProvider>
    </ThemeProvider>
  );
}

export default App;
